import { getGlobal } from "../lib/get-global";
import { MetadataPlugin } from "./metadata";

export const createCookiePlugin: MetadataPlugin = function () {
  const globalThis = getGlobal();

  if (
    typeof globalThis === "undefined" ||
    typeof localStorage === "undefined"
  ) {
    return {
      getValue() {
        return {};
      },
    };
  }

  const ID_KEY = "spindl_id";
  const PREV_ID_KEY = "spindl_prev_id";

  let identity = localStorage.getItem(ID_KEY) || undefined;
  let prevIdentity = localStorage.getItem(PREV_ID_KEY) || undefined;

  function getValue() {
    return {
      identity,
      prevIdentity,
    };
  }

  return {
    getValue,
  };
};
